export const list = {
  REQUEST: 'OData/Request',
  SUCCESS: 'OData/Success',
  FAILURE: 'OData/Failure',
  RESET: 'OData/Reset'
};

export const XLS = {
  REQUEST: 'ODataXls/Request',
  SUCCESS: 'ODataXls/Success',
  FAILURE: 'ODataXls/Failure'
};
